import { ready } from "./utils";
import { locationModal } from "./location-modal-window";
import { snyderSliders } from "./sliders";
ready(() => {
  locationModal();
  snyderSliders();
});
